// extracted by mini-css-extract-plugin
module.exports = {"pdqsContainer":"pdq-transactions_pdqsContainer__3Yy8i"};